module.exports = __webpack_public_path__ + "static/media/control-rojo.62b51fbe.svg";